import { render } from "./ButtonIcon.vue?vue&type=template&id=602a6cf1&scoped=true&ts=true"
import script from "./ButtonIcon.ts?vue&type=script&lang=ts&external"
export * from "./ButtonIcon.ts?vue&type=script&lang=ts&external"

import "./ButtonIcon.scss?vue&type=style&index=0&id=602a6cf1&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602a6cf1"]])

export default __exports__